import app from 'app';

app.constant('SubmitClaimBillUploadConstants', {
  status: {
    TOO_BIG: 'File too big',
    UPLOADING: 'Uploading',
    UPLOADED: 'Uploaded',
    FAILED: 'Upload failed',
    WRONG_TYPE: 'Wrong file type',
  },
});
